import { render } from "./PublicHeader.vue?vue&type=template&id=e1fabe50&scoped=true&ts=true"
import script from "./PublicHeader.vue?vue&type=script&lang=ts"
export * from "./PublicHeader.vue?vue&type=script&lang=ts"

import "./PublicHeader.vue?vue&type=style&index=0&id=e1fabe50&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1fabe50"],['__file',"src/components/header/PublicHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e1fabe50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e1fabe50', __exports__)) {
    api.reload('e1fabe50', __exports__)
  }
  
  module.hot.accept("./PublicHeader.vue?vue&type=template&id=e1fabe50&scoped=true&ts=true", () => {
    api.rerender('e1fabe50', render)
  })

}


export default __exports__